// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2IwRX","buttons":"SendReceipts_buttons__1ystw","email":"SendReceipts_email__29Qfp","bookApptTitle":"SendReceipts_bookApptTitle__iL2gq"};